import React, { useState, useEffect, Fragment, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, useNavigate } from "react-router-dom";
import {
  setPreviousEmpDataActions,
  setPreviousEmpDataCreateActions,
  setPreviousEmpDataeditActions,
  SetDeclarationId, ///decalration form
  SetActiveTabs, ///-------------_____Active-----Tabs
} from "../../../Redux/Slice";
import { Grid, Typography, Button } from "@material-ui/core";
import ReactCrop from "react-image-crop";
import { elements } from "chart.js";
import { toast } from "react-toastify";
import "react-image-crop/dist/ReactCrop.css";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";
import { store } from "../../../Redux/Store";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
 import PlusIcon from "../../../Assets/AppComponent/Asset 9.svg"
 import minus from "../../../Assets/AppComponent/Asset 10.svg"

const PreviousEmp = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const initialState = {
    company_name: "",
    start_date: "",
    end_date: "",
    years_of_experience: "",
    designation: "",
  };
  const [data, setDatas] = useState(initialState);
  const [fresher, setFresher] = useState(false);

  // Athena only: up to 2 references (personal + previous employer), all optional text
  const organization = useSelector(
    (state) => state.NumberCounts.selectedOnoardClient,
  );
  const isAthena =
    organization?.organization?.id == "28e108e0-a644-4365-89df-317867f00f22";
  const REFERENCE_FIELDS = [
    ["ref_name", "Ref Name"],
    ["relationship", "Relationship with candidate"],
    ["known_years", "Known for no. of yrs"],
    ["character", "Character"],
    ["education", "Educational Background"],
    ["previous_employment", "Previous employment"],
    ["strengths", "Strengths"],
    ["weakness", "Weakness"],
    ["other_info", "Any other information"],
  ];
  const PREVIOUS_EMPLOYER_REFERENCE_FIELDS = [
    ["ref_name", "Ref Name"],
    ["designation", "Designation"],
    ["known_years", "Known for no. of yrs"],
    ["feedback", "Feedback"],
    ["strengths", "Strengths"],
    ["weakness", "Weakness"],
    ["other_info", "Any other information"],
  ];
  const blankReference = (fields) =>
    fields.reduce((acc, [key]) => ({ ...acc, [key]: "" }), {});
  const [references, setReferences] = useState([blankReference(REFERENCE_FIELDS)]);
  const [previousEmployerReferences, setPreviousEmployerReferences] = useState([
    blankReference(PREVIOUS_EMPLOYER_REFERENCE_FIELDS),
  ]);
  // drop blank references; null when nothing is filled
  const cleanReferences = (list, fields) => {
    const filled = (Array.isArray(list) ? list : [])
      .map((item) =>
        fields.reduce((acc, [key]) => ({ ...acc, [key]: item?.[key] || "" }), {}),
      )
      .filter((item) => Object.values(item).some((value) => value !== ""));
    return filled.length ? filled : null;
  };
  // references belong to the employee, they are sent on the first previous-details row
  const withReferences = (rows) =>
    !isAthena
      ? rows
      : rows.map((row, index) =>
          index !== 0
            ? row
            : {
                ...row,
                reference_details: cleanReferences(references, REFERENCE_FIELDS),
                previous_employer_reference_details: fresher
                  ? null
                  : cleanReferences(
                      previousEmployerReferences,
                      PREVIOUS_EMPLOYER_REFERENCE_FIELDS,
                    ),
              },
        );
  const handleReferenceChange = (setter, list, index, key, value) => {
    const updated = [...list];
    updated[index] = { ...updated[index], [key]: value };
    setter(updated);
  };
  const handleReferenceAdd = (setter, list, fields) => {
    if (list.length < 2) setter([...list, blankReference(fields)]);
  };
  const handleReferenceRemove = (setter, list, index) => {
    setter(list.filter((_, i) => i !== index));
  };

  // load the saved references from the first previous-details row
  useEffect(() => {
    const first = state.PreviousEmp.PreviousEmpData?.[0];
    if (!first) return;
    const saved = first.reference_details;
    const savedEmployer = first.previous_employer_reference_details;
    setReferences(
      Array.isArray(saved) && saved.length
        ? saved.slice(0, 2)
        : [blankReference(REFERENCE_FIELDS)],
    );
    setPreviousEmployerReferences(
      Array.isArray(savedEmployer) && savedEmployer.length
        ? savedEmployer.slice(0, 2)
        : [blankReference(PREVIOUS_EMPLOYER_REFERENCE_FIELDS)],
    );
  }, [state.PreviousEmp.PreviousEmpData]);

  const formdata = new FormData();
  const [CompanyErr, setCompaneErr] = useState("");
  const [StartErr, setStarErr] = useState("");
  const [EndEr, setEndErr] = useState("");
  const [DesginationErr, setDesginationErr] = useState("");
  const [YearErr, setYearErr] = useState("");
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
  const [areMappedArraysEqual , setareMappedArraysEqual] = useState(false)

  const [url, setUrl] = useState();
  // console.log(url);
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [eventFiles, seteventfiles] = useState()
    //// present---url
  const [PresentUrls , setPresentUrls] = useState([])

  const [crop, setCrop] = useState();

  const fixedCropSize = { width: 300, height: 200 };

  const [imageFileChange, setImageFileChange] = useState([
    false,
    false,
    false,
    false,
  ]);
   const fileInputRef = useRef()
  const [updateImage, setUpdateImage] = useState([false, false, false, false]);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [images, setImages] = useState([]);
  const [imagesFile, setImagesFile] = useState([]);
  // console.log(images, imagesFile, "imagefiled65213");
  const [forindex, setforindex] = useState();
  const [updated, setupdatefile] = useState(false);
  const [RetrieveFesher, setRetrieveFresher] = useState(false);
  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  ///----iS---FRESHER------
  useEffect(() => {
    if (
      state.FormsIDList.PreviousempID != undefined &&
      state.FormsIDList.PreviousempID != "" &&
      state.PreviousEmp.PreviousEmpData != undefined &&
      state.PreviousEmp.PreviousEmpData[0] != undefined &&
      state.PreviousEmp.PreviousEmpData[0].is_fresher != undefined
    ) {
      setFresher(state.PreviousEmp.PreviousEmpData[0].is_fresher);
      setRetrieveFresher(state.PreviousEmp.PreviousEmpData[0].is_fresher);
    }
  }, [state.PreviousEmp.PreviousEmpData]);

  useEffect(() => {
    var defaultFields = [];

    if (state.FormsIDList.PreviousempID == "") {
      defaultFields = [
        {
          company_name: "",
          start_date: "",
          end_date: "",
          years_of_experience: "",
          designation: "",
          month_of_experience: "",
          Files: "",
          file: "",
          id:null,
          certificate:"",
          is_fresher:false
        },
      ];
    }

    // If state.FamilyList.FamilyDetails exists, update inputFields
    if (
      state.FormsIDList.PreviousempID !== "" &&
      state.PreviousEmp.PreviousEmpData !== undefined &&
      state.PreviousEmp.PreviousEmpData !== null
    ) {
      setInputFields(
        defaultFields.concat(
          state.PreviousEmp.PreviousEmpData.map((item) => ({
            company_name: item.company_name,
            start_date: item.start_date,
            end_date: item.end_date,
            years_of_experience: item.years_of_experience,
            designation: item.designation,
            month_of_experience: item.month_of_experience,
            id:item.id,
            is_fresher: false,
            certificate:item.certificate_id != undefined &&
            item.certificate_id != null &&
            item.certificate_id.media_url != undefined &&
            item.certificate_id.media_url != null &&
            item.certificate_id.media_url,


            Files:
              item.certificate_id != undefined &&
              item.certificate_id != null &&
              item.certificate_id.media_url != undefined &&
              item.certificate_id.media_url != null &&
              item.certificate_id.media_url,
          }))
        )
      );
      setCompaneErr("");
      setStarErr("");
      setEndErr("");
      setYearErr("");
      setDesginationErr("");
    } else {
      setInputFields(defaultFields);
    }
  }, [state.PreviousEmp.PreviousEmpData]);


  const [inputFields, setInputFields] = useState([]);

  const HandleAddFieldsFile = () => {
    const FilesVal = [...File];
    const count = Math.random();
    console.log(Math.round(count), "count");
    // FilesVal.push({
    //   file: [],
    //   url: "",
    // });
    // setFile(FilesVal);
  };

 
console.log(inputFields ,"129-83inputField");

  const handleAddFields = (index) => {
     if(inputFields.length != 10){ 

    const values = [...inputFields];
    values.push({
      company_name: "",
      start_date: "",
      end_date: "",
      years_of_experience: "",
      designation: "",
      month_of_experience: "",
      Files: "",
      file: "",
      id:null,
      is_fresher:false,


    });

    setInputFields(values);
    setImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = "";
      return newImages;
    });

    const updatedImagesFile = [...imagesFile];

    updatedImagesFile[forindex] = "";
    setImagesFile(updatedImagesFile);
  }
  else {
    toast.error(
      ` ${"You cannot add more than 20 experience fields."} `,
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );

  }
  }; 
   console.log(inputFields , "2387480sninputFields");

  const handleRemoveFields = (index) => {
     console.log(index , "3e7s08jindex");
    const values = [...inputFields];
    values.splice(index, 1);
    setImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = "";
      return newImages;
    });
    setInputFields(values);
    const updatedImagesFile = [...imagesFile];

    updatedImagesFile[forindex] = "";
    setImagesFile(updatedImagesFile);
  };
  const calculateYearsOfExperience = (startDate, endDate) => {
    // Assuming startDate and endDate are in ISO format ('YYYY-MM-DD')
    const start = new Date(startDate);
    const end = new Date(endDate);
    const yearsOfExperience = end.getFullYear() - start.getFullYear();
    console.log(yearsOfExperience, "yearsOfExperience");
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];

    const calculateExperience = (start, end) => {
      const startDate = new Date(start);
      const endDate = new Date(end);
    
      if (!isNaN(startDate) && !isNaN(endDate) && startDate <= endDate) {
        let years = endDate.getFullYear() - startDate.getFullYear();
        let months = endDate.getMonth() - startDate.getMonth();
        let days = endDate.getDate() - startDate.getDate();
    
        if (days < 0) {
          months--;
          const previousMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
          days += previousMonth.getDate();
        }
    
        if (months < 0) {
          years--;
          months += 12;
        }
    
        return { years, months, days };
      }
      return { years: "", months: "", days: "" };
    };
    
    
    // if (event.target.name === "company_name") {
    //   values[index].company_name = event.target.value.toUpperCase();
    // } else if (event.target.name === "start_date") {
    //   values[index].start_date = event.target.value;
    // } else if (event.target.name === "end_date") {
    //   values[index].end_date = event.target.value;
    // } else if (event.target.name === "years_of_experience") {
    //   values[index].years_of_experience = event.target.value.slice(0, 2);
    // } else if (event.target.name === "designation") {
    //   values[index].designation = event.target.value.toUpperCase();
    // } else if (event.target.name === "month_of_experience") {
    //   values[index].month_of_experience = event.target.value;
    // } else if (event.target.name === "file") {

    if (event.target.name === "company_name") {
      values[index].company_name = event.target.value.toUpperCase();
    } else if (
      event.target.name === "start_date" ||
      event.target.name === "end_date"
    ) {
      values[index][event.target.name] = event.target.value;
      const experience = calculateExperience(
        values[index].start_date,
        values[index].end_date
      );
      values[index].years_of_experience = experience.years.toString();
      values[index].month_of_experience = experience.months.toString();
    } else if (event.target.name === "years_of_experience") {
      values[index].years_of_experience = event.target.value.slice(0, 2);
    } else if (event.target.name === "month_of_experience") {
      values[index].month_of_experience = event.target.value.slice(0, 2);
    } else if (event.target.name === "designation") {
      values[index].designation = event.target.value.toUpperCase();
    } else if (event.target.name === "file") {
      setalert(true);
      // images.map((item)=>{
      //   values[index].Files = item;
      // })
      seteventfiles(event)

      //console.log(event.target.files[0], "evefasfsdl");
      // selectedImage(event, index);
      setCroppImageViewCount(index);
      setCroppImageView(true);

      const file = event.target.files[0];

      const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      const maxSize = 10 * 1024 * 1024; // 3MB in bytes
      const MIN_DIMENSION = 150;

      if (file && allowedTypes.includes(file.type)) {
        if (file.size > maxSize) {
          setCroppImageView(false);
          toast.error("File size exceeds 10MB. Please upload a smaller image.");
        } else {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;
    
            imageElement.addEventListener("load", (imgEvent) => {
              const { naturalWidth, naturalHeight } = imgEvent.currentTarget;
    
              if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                toast.error("Image must be at least 150 x 150 pixels.");
                setCroppImageView(false);
                return;
              }
                selectedImage(event, index); // Continue processing the image
            });
          });
          reader.readAsDataURL(file); // Read the file as a data URL
        }
      } else {
        setCroppImageView(false);
        toast.error("Please upload an image file (jpg, jpeg, png, svg).");
        // e.target.value = ""; // Clear the file input
      }

    }

    if (
      event.target.name === "start_date" ||
      event.target.name === "end_date"
    ) {
      calculateYearsOfExperience(event.target.value, event.target.value);
    }

    setInputFields(values);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // handle form submission here
    // alert(JSON.stringify(inputFields, null, 2));


  };


  useEffect(() => {
    if (
      state.FormsIDList.PreviousempID != "" &&
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
      state.FormsIDList.ActiveTabs == 6
    ) {
      let payload = {
        Retieveid: state.FormsIDList.PreviousempID,
        UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
      };

      console.log('podipoei' , state.FormsIDList.PreviousempID);


      dispatch(setPreviousEmpDataActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);

  const selectedImage = (e) => {
    console.log(e.target.files[0], "e.target.files[0]");
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };
  const setCompletedCrop = async (c, index) => {
    try {
      // Call getCroppedImg function to get the cropped image data
      const croppedImageUrl = await getCroppedImg(
        imgRef.current,
        c,
        "newfile.jpeg"
      );
    } catch (error) {
      console.error("Error cropping image:", error);
    } finally {
      setCroppImageView(false); // Close cropping interface
    }
  };

  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };

  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");
  
    ctx.drawImage(
        imageRef.current,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY
    );
  

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        console.log(blob, "blob");
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        if(croppedFile){
          setTimeout(() => {
            setCroppImageView(false)
      
          }, 0);
         }
  
        setImageFileChange((prevState) => {
          const newState = [...prevState];
          newState[forindex] = true;
          return newState;
        });

        const valuesFile = [...inputFields]; ///file
        valuesFile[forindex].file = croppedFile; // Assuming you have a field for croppedImageData
        setInputFields(valuesFile);

        const updatedImagesFile = [...imagesFile];
        // console.log(imagesFile, "imagesFile");
        updatedImagesFile[forindex] = croppedFile;
        setImagesFile(updatedImagesFile);


        var fileBase = croppedFile;
        var reader = new FileReader();

        const generateRandomNumber = () => {
          return Math.floor(Math.random() * 100000); 
        };
        
        const createPresentData = (croppedFile) => {
          const randomNumber = generateRandomNumber();
          const formattedFilename = `onboarding/experience/experience${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
          const Presentdata = {
            multiple_files: [
              {
                filename: formattedFilename,
                file_type: croppedFile.type,
              },
            ],
          };
        
          return Presentdata;
        };
        
        const Presentdata = createPresentData(croppedFile);

        setupdatefile(true);

        axios( {
          url:PresentUrl,
          method:'post',
          data: Presentdata,
          headers: {
            Authorization:
              "Bearer " + store.getState().users.UserData.session.token,
          },
        })
        .then((response) => {
          console.log('Files uploaded successfully:', response.data);
          const uploadedFiles = response.data.data; 
          
          const newUrls = uploadedFiles.map(file => ({
            url: file, 
            type: croppedFile.type,
            putfiles:croppedFile

          }));
        
          // Update PresentUrls state
          setPresentUrls(prevUrls => {
            const updatedUrls = [...prevUrls];
            updatedUrls[forindex] = newUrls[0];
            return updatedUrls;
        });
          
  ////---store the ----certificate ---url 
  const values = [...inputFields]; 
          values[forindex].certificate = String(response.data.data).split("?")[0]; 
          setInputFields(values);


        })
        .catch((error) => {
          console.error('Error uploading files:', error);
        });

        reader.onloadend = function () {
          setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[forindex] = reader.result;
            return newImages;
          });

          const values = [...inputFields]; 
          values[forindex].Files = reader.result; 
          setInputFields(values);

        };


        
        reader.readAsDataURL(fileBase);
        blob.name = fileName;
        let fileUrl = window.URL.createObjectURL(blob);
        console.log(fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  }


  //console.log(images, "updatedImagesFile", imagesFile);

  ///--------------------------
  const [stateForm, setSatusCheck] = useState(false);
  useEffect(() => {
    if (state.FormsIDList.PreviousempID != "") {
      state.PreviousEmp.PreviousEmpData.map((item) => {
        if (
          item.company_name != undefined &&
          item.designation != "" &&
          item.end_date != "" &&
          item.start_date != "" &&
          item.years_of_experience != ""
        ) {
          setSatusCheck(true);
        }
      });
    }
  }, []);
  const updateAvatar = (imgSrc) => {
    fileInputRef.current.value = imgSrc;
  };
  useEffect(() => {
    const array1 = inputFields;
    const array2 = state.PreviousEmp.PreviousEmpData;
  
    // Mapping the arrays to objects containing the fields of interest
    const mappedArray1 = array1.map((item) => ({
      company_name: item.company_name,
      designation: item.designation,
      end_date: item.end_date,
      start_date: item.start_date,
      years_of_experience: item.years_of_experience,
      is_fresher: fresher,
    }));
  
    const mappedArray2 = array2.map((item) => ({
      company_name: item.company_name,
      designation: item.designation,
      end_date: item.end_date,
      start_date: item.start_date,
      years_of_experience: item.years_of_experience,
      is_fresher: item.is_fresher,
    }));
  
    // Function to check if two arrays of objects are equal
    const arraysAreEqual = (arr1, arr2) => {
      if (arr1.length !== arr2.length) {
        return false;
      }
  
      // Loop through each element and compare objects
      for (let i = 0; i < arr1.length; i++) {
        // Check if all keys and values match
        if (JSON.stringify(arr1[i]) !== JSON.stringify(arr2[i])) {
          return false;
        }
      }
  
      return true;
    };
   // a change only in the references must also count as an edit
   const savedFirst = array2?.[0];
   const referencesUnchanged =
     !isAthena ||
     (JSON.stringify(cleanReferences(references, REFERENCE_FIELDS)) ===
       JSON.stringify(cleanReferences(savedFirst?.reference_details, REFERENCE_FIELDS)) &&
       (fresher ||
         JSON.stringify(
           cleanReferences(previousEmployerReferences, PREVIOUS_EMPLOYER_REFERENCE_FIELDS),
         ) ===
           JSON.stringify(
             cleanReferences(
               savedFirst?.previous_employer_reference_details,
               PREVIOUS_EMPLOYER_REFERENCE_FIELDS,
             ),
           )));
   setareMappedArraysEqual(arraysAreEqual(mappedArray1, mappedArray2) && referencesUnchanged)

  }, [state.PreviousEmp.PreviousEmpData, inputFields, fresher, references, previousEmployerReferences]);
  
  console.log(images, "images");
  const [updateddata, setupdateddata] = useState();
  const [UpdatedPreviousEdit, setupdatedPreviousEdit] = useState();

  useEffect(() => {
    var mappedOne = [];
    if (inputFields != null) {
      inputFields.forEach((item, index) => {
        if (item != null && item != undefined) {
          const filteredProperties = {};
          Object.entries(item).forEach(([subkey, subvalue]) => {
            if (!subkey.includes("Files") && !subkey.includes("file")) {
              filteredProperties[subkey] = subvalue;
            }
          });

          const for_fresher = {
            data: [
              {
                company_name: "",
                is_fresher: fresher,
                designation: "",
                start_date: null,
                end_date: null,
                years_of_experience: "",
                month_of_experience: "",
                certificate: ""
              }
            ]
          };          mappedOne.push(filteredProperties);
           const data ={ 
            data: withReferences(fresher == true ? for_fresher.data : mappedOne),
            timeline_id:  state.BasicFormCreated.BasciFormCreate == ""
            ? state.EmployeeProfile.EmployeeProfileList.id
            : state.BasicFormCreated.BasciFormCreate,
            // user_id:state.EmployeeProfile.EmployeeProfileList.user_id.id
           }
           
          
          setupdateddata(data);
        }
      });
    }

    // console.log("mappedOne", mappedOne, updateddata);
  }, [inputFields , fresher, references, previousEmployerReferences]);


  useEffect(() => {
    var mappedOne = [];
    if (inputFields != null) {
      inputFields.forEach((item, index) => {
        // console.log(index, item, "inputFieldssfadasd");

        if (item != null && item != undefined) {
          const filteredProperties = {};
          Object.entries(item).forEach(([subkey, subvalue]) => {
            if (!subkey.includes("Files") && !subkey.includes("file")) {
              filteredProperties[subkey] = subvalue;
            }
          });
          const for_fresher = {
            data: [
              {
                company_name: "",
                designation: "",
                is_fresher: fresher,
                start_date: null,
                end_date: null,
                years_of_experience: "",
                month_of_experience: "",
                certificate: ""
              }
            ]
          };
          mappedOne.push(filteredProperties);
           const data ={ 
            data: withReferences(fresher == true ? for_fresher.data : mappedOne),
            timeline_id:  state.BasicFormCreated.BasciFormCreate == ""
            ? state.EmployeeProfile.EmployeeProfileList.id
            : state.BasicFormCreated.BasciFormCreate,
            user_id:state.BasicFormCreated.user_ID
           }
           
          
           setupdatedPreviousEdit(data);
        }
      });
    }
  }, [inputFields , fresher, references, previousEmployerReferences]);



  const HandleNext = () => {
    var a = 0;

    if (
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.declaration_form != null &&
      state.EmployeeProfile.EmployeeProfileList.declaration_form != undefined &&
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.EmployeeProfile.EmployeeProfileList.declaration_form.id != undefined
    ) {
      dispatch(
        SetDeclarationId(
          state.EmployeeProfile.EmployeeProfileList.declaration_form.id
        )
      );
    }




    const fetchUploadFiles = async () => {       
      await Promise.all(PresentUrls.map(async (item) => {      
        try {
           if(item != undefined && item != null){ 
          const response = await fetch(item.url, {
            method: 'PUT',
            headers: {
              'Content-Type': item.type,
              "x-amz-acl":"public-read"
            },
            body: item.putfiles,
          });
        }
        } catch (error) {
          console.error('Error uploading files:', error);
        }
      }));
    };

    if (!fresher) {

      inputFields.map((item) => {
        console.log(item , "182634e98ditem");
       //  if(state.NumberCounts.Editable != 1){ 
       if (item.company_name == ""|| item.company_name == null || item.company_name == undefined) {
         setCompaneErr("*Company Name is required");
         a = 1;
       }
    
    
       if (item.start_date == ""|| item.start_date == null || item.start_date == undefined) {
         setStarErr("*Start Date is required");
         a = 1;
       }
       if (item.end_date == ""|| item.end_date == null || item.end_date== undefined) {
         setEndErr("*End Date is required");
         a = 1;
       }
    
       if (item.designation == ""|| item.designation == null || item.designation == undefined) {
         setDesginationErr("*Designation  is required");
         a = 1;
       }
    
       if (item.years_of_experience == ""
         ||  item.years_of_experience == null || item.years_of_experience == undefined
       ) {
         setYearErr("*Year of Experience  is required");
         a = 1;
       }
     // }
     });
    
    }
    
    else if(fresher === true){
a = 0 ;
    } 


    
    if (state.FormsIDList.PreviousempID == "") {

      if(updated  == true &&  a == 0){ 

        fetchUploadFiles()
    }
    
       if (a == 0) {
        formdata.append(
          "timeline_id",
          state.BasicFormCreated.BasciFormCreate == ""
            ? state.EmployeeProfile.EmployeeProfileList.id
            : state.BasicFormCreated.BasciFormCreate
        );

        const payload = {
          formdata: updateddata,
        };
        dispatch(setPreviousEmpDataCreateActions(payload));
        setPresentUrls([]);
    }
      
    } else if (
      state.FormsIDList.PreviousempID != ""
          &&
          state.FormsIDList.PreviousempID != undefined
          &&
          areMappedArraysEqual == false
          || updated == true   ) {


      if(updated == true && a == 0){ 

        fetchUploadFiles()
    }

    

      if (a == 0 ) {
        // console.log(fresher, "freshsdaser");
        if (!fresher) {
          formdata.append("data", JSON.stringify(updateddata));
          if (updated) {
            // imagesFile.forEach(element, index => {
            //   formdata.append(`certificate_${index}`, element);
            // });
            imagesFile.forEach((element, index) => {
               if(element != undefined){ 
              formdata.append(`certificate_${index}`, element);
               }
            });
          }
  
        }


        if (fresher) {
          formdata.append("data", JSON.stringify([{ is_fresher: fresher }]));
        }

        const payload = {
          // formdata: formdata,
          formdata: UpdatedPreviousEdit,
          Retieveid: state.FormsIDList.PreviousempID,
        };
      

      
      
        dispatch(setPreviousEmpDataeditActions(payload));
        // dispatch(SetActiveTabs(7));
        dispatch(SetActiveTabs(8));
        setPresentUrls([]);
      }
      // } -------------------------------////-----------PREBUOUS)))EMPLOYEE-------_____EDIT-----

      // dispatch(SetActiveTabs(7));
    } else if ( a == 0 && RetrieveFesher == fresher && areMappedArraysEqual == true) {
      // dispatch(SetActiveTabs(7))
      dispatch(SetActiveTabs(8));
    }
  };
  // one block (Reference / Previous Employer Reference): Ref 1 + a "+" button for Ref 2
  const renderReferenceSection = (title, list, setter, fields) => (
    <div style={{ padding: "15px" }}>
      <h6 style={{ fontWeight: 600, margin: "10px 0 15px" }}>{title}</h6>
      {list.map((reference, index) => (
        <div
          key={`${title}-${index}`}
          className="form-row"
          style={{ marginBottom: "15px" }}
        >
          <div
            className="form-group col-sm-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <b>{`Ref ${index + 1}`}</b>
            <div style={{ display: "flex", gap: "20px" }}>
              {index !== 0 ? (
                <button
                  type="button"
                  className="DeclineStatusPrev "
                  onClick={() => handleReferenceRemove(setter, list, index)}
                >
                  <span>
                    <img src={minus} />
                  </span>
                </button>
              ) : null}
              {index === 0 && list.length < 2 ? (
                <button
                  type="button"
                  className="AddFields "
                  onClick={() => handleReferenceAdd(setter, list, fields)}
                >
                  <span className="PlusButton">
                    <img src={PlusIcon} />
                  </span>
                </button>
              ) : null}
            </div>
          </div>
          {fields.map(([key, label]) => (
            <div className="form-group col-sm-3" key={key}>
              <label className="form-label">{label}</label>
              <input
                type="text"
                className="form-control"
                value={reference[key] || ""}
                onChange={(e) =>
                  handleReferenceChange(setter, list, index, key, e.target.value)
                }
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );

  const preventTyping = (e) => {
    e.preventDefault();
  };
  function onFocus(event) {
    event.target.showPicker();
  }
  console.log(inputFields ,"inputFileds0283091283", updated , PresentUrls.map((item)=>{console.log("ioeuroiweur",item);
  }) , PresentUrls[0],PresentUrls[1],  PresentUrls);
  
  

  return (
    <>
      <div className=" BodyContent">
        <div className="card">
          <div className="card-body cards ">
            <div className="UserPoup">
              <div className="BeforForms">
                <div className="Form">
                  <div className="ModalHeader">
                    <div>
                      <span>Previous Employee Details</span>
                    </div>
                  </div>
                  {
                    //state.PreviousEmp.PreviousEmpData[0] != undefined &&
                    state.NumberCounts.Editable == 1 &&
                      state.ClientBranchIDs.SUBROLE != 3 &&
                      // (state.PreviousEmp.PreviousEmpData[0].id ==
                      //   state.FormsIDList.PreviousempID) !=
                      //   "" &&
                      state.PreviousEmp.PreviousEmpData.map((item, index) => (
                        <>
                          {item.is_fresher &&
                          state.NumberCounts.Editable == 1 &&
                          state.ClientBranchIDs.SUBROLE != 3 ? (
                            <div className="row">
                              <div className="col-12 mt-4 text-center">
                                <label className="form-label">
                                  Employee is fresher
                                </label>
                              </div>
                            </div>
                          ) : (
                            <>
                              {state.ClientBranchIDs.SUBROLE != 3 ? (
                                <div className="Modal-Body" key={index}>
                                  <div className="row Filters">
                                    <div className="col mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Company Name
                                      </label>
                                      {/* <input
                                    type="text"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    // value={data.company_name}
                                    value={item.company_name}
                                    name="company_name"
                                    readOnly={
                                      state.NumberCounts.Editable == 1
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => {
                                      HandleChanges(e);
                                    }}
                                  /> */}
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="validationCustom01"
                                        autoComplete="off"
                                        value={item.company_name || ""}
                                        name="company_name"
                                        readOnly={
                                          state.NumberCounts.Editable === 1
                                        }
                                        onChange={(e) => {
                                          const newValue = e.target.value;
                                          HandleChanges(e); // If you need to handle other changes too
                                          // setCompanyName(newValue); // Update the local state
                                        }}
                                      />
                                    </div>

                                    <div className="col mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Designation
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        id="validationCustom01"
                                        autocomplete="off"
                                        name="designation"
                                        value={item.designation}
                                        readOnly={
                                          state.NumberCounts.Editable == 1
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          HandleChanges(e);
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Start Date
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        id="validationCustom01"
                                        autocomplete="off"
                                        name="start_date"
                                        value={item.start_date}
                                        readOnly={
                                          state.NumberCounts.Editable == 1
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          HandleChanges(e);
                                        }}
                                        onKeyDown={preventTyping}

                                      />
                                    </div>
                                    <div className="col mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        End Date
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        id="validationCustom01"
                                        autocomplete="off"
                                        name="end_date"
                                        value={item.end_date}
                                        readOnly={
                                          state.NumberCounts.Editable == 1
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          HandleChanges(e);
                                        }}
                                        onKeyDown={preventTyping}

                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-6 mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Years of Experience
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        id="validationCustom01"
                                        autocomplete="off"
                                        name="years_of_experience"
                                        value={item.years_of_experience}
                                        readOnly={
                                          state.NumberCounts.Editable == 1
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          HandleChanges(e);
                                        }}
                                      />
                                    </div>
                                    {state.PreviousEmp.PreviousEmpData
                                      .certificate_id != undefined &&
                                    state.PreviousEmp.PreviousEmpData
                                      .certificate_id.media_url != undefined &&
                                    state.PreviousEmp.PreviousEmpData
                                      .certificate_id.media_url != null ? (
                                      <div className="col mt-3">
                                        <div>
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            File
                                          </label>
                                          <input type="file" hidden />
                                          <a
                                            href={item.certificate_id.media_url}
                                            target="blank"
                                          >
                                            <div
                                              style={{
                                                width: "177px",
                                                height: "111px",
                                              }}
                                            >
                                              <img
                                                src={
                                                  item.certificate_id.media_url
                                                }
                                                //  format={state.EducationAction.EducationData.sscl_id.file_extension}
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                }}
                                                alt="File Preview"
                                              />
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              ) : null}
                              {/* <form id="myForm"></form> */}
                            </>
                          )}
                        </>
                      ))
                  }
                  {state.NumberCounts.Editable == 2 ||
                  state.ClientBranchIDs.SUBROLE == 3 ? (
                    <>
                      {
                        <>
                          <div className="row" style={{ padding: "10px 42px" }}>
                            <div className="col-6 mt-3">
                              <input
                                style={{ cursor: "pointer" }}
                                type="checkbox"
                                class="form-check-input"
                                checked={fresher}
                                onChange={(e) => {


                                  setFresher(!fresher);
                                  setCompaneErr("");
                                  
                                  setStarErr("");
                                  setEndErr("");
                                  setDesginationErr("");
                                  setYearErr("")

                                }}
                              />
                              <label  className="form-label">Employee is fresher ?</label>
                            </div>
                          </div>
                        </>
                      }

                      {!fresher ? (
                        <>
                          <form onSubmit={handleSubmit}>
                            <div
                              className="form-row Fragements"
                              style={{ padding: "15px" }}
                            >
                              {inputFields.map((inputField, index) => (
                                <Fragment key={`${inputField}~${index}`}>
                                  <div
                                    className="form-group col-sm-12"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    {/* <button
                                    className="btn btn-link"
                                    type="button"
                                    disabled={index === 0}
                                    onClick={() => handleRemoveFields(index)}
                                  >
                                    x
                                  </button> */}
                                    <div
                                      className=" btn  StatusList"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",

                                        gap: "20px",
                                      }}
                                    >
                                      {index !== 0 ? 
                                      <button
                                        className="DeclineStatusPrev "
                                        disabled={index === 0}
                                        onClick={() => {
                                          handleRemoveFields(index);
                                        }}
                                      >
                                        <span>
                                          {/* x */}
                                          {/* <i class="fa-solid fa-xmark"></i> */}
                                            <img src={minus}/>
                                        </span>
                                      </button>
                                      :
                                       null }
{index == 0 ? 
                                      <button
                                        className="AddFields "
                                        onClick={(index) => {
                                          handleAddFields(index);
                                        }}
                                      >
                                        <span className="PlusButton">
                                          <img src={PlusIcon}/>
                                        </span>
                                      </button>
                                      : null }
                                    </div>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label htmlFor="firstName"                                         class="form-label"
                                     >
                                      Company Name
                                    </label>
                                    <span style={{ color: "red" }}>*</span>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id="firstName"
                                      name="company_name"
                                      value={inputField.company_name}
                                      onChange={(event) => {
                                        handleInputChange(index, event);
                                        setCompaneErr("");
                                      }}
                                      autoComplete="off"
                                    />
                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {
                                        inputField.company_name != "" && inputField.company_name != null && inputField.company_name != undefined ? "":                                     CompanyErr}
                                    </p>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label htmlFor="lastName"                                         class="form-label"
                                    >
                                      {" "}
                                      Start Date
                                    </label>
                                    <span style={{ color: "red" }}>*</span>


                                    <input
                                      type="date"
                                      className="form-control"
                                      id="lastName"
                                      name="start_date"
                                      value={inputField.start_date}
                                      onChange={(event) => {
                                        handleInputChange(index, event);
                                        setStarErr("");
                                      }}
                                      max={today} // Set the max attribute to today's date
                                      autoComplete="off"
                                      onKeyDown={preventTyping}
                                      onClick={onFocus}
                                      // onFocus={(e) => e.target.showPicker()}

                                    />

                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {inputField.start_date != "" && inputField.start_date != null && inputField.start_date != undefined ?"":StartErr }
                                      
                                    </p>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label htmlFor="lastName"                                         class="form-label"
                                    > End Date</label>
                                    <span style={{ color: "red" }}>*</span>

                                    <input
                                      type="date"
                                      className="form-control"
                                      id="lastName"
                                      name="end_date"
                                      value={inputField.end_date}
                                      onChange={(event) => {
                                        handleInputChange(index, event);
                                        setEndErr("");
                                        setYearErr("");
                                      }}
                                      autoComplete="off"
                                      onKeyDown={preventTyping}
                                      onClick={onFocus}
                                      // onFocus={(e) => e.target.showPicker()}
                                      max={today} // Set the max attribute to today's date
                                    />
                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {inputField.end_date != "" && inputField.end_date != null && inputField.end_date != undefined? "": EndEr}
                                    </p>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label htmlFor="lastName"                                         class="form-label"
                                    >
                                      Year Of Experience
                                    </label>
                                    <span style={{ color: "red" }}>*</span>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="lastName"
                                      name="years_of_experience"
                                      value={inputField.years_of_experience}
                                      onChange={(event) => {
                                        handleInputChange(index, event);
                                        setYearErr("");
                                      }}
                                      disabled
                                      autoComplete="off"
                                    />
                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {inputField.years_of_experience != "" && inputField.years_of_experience != undefined && inputField.years_of_experience != null ? "": YearErr}
                                    </p>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label htmlFor="lastName"                                         class="form-label"
                                    >
                                      Designation
                                    </label>
                                    <span style={{ color: "red" }}>*</span>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id="lastName"
                                      name="designation"
                                      value={inputField.designation}
                                      onChange={(event) => {
                                        handleInputChange(index, event);
                                        setDesginationErr("");
                                      }}
                                      
                                      autoComplete="off"
                                    />
                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      
                                      {inputField.designation != "" && inputField.designation != null && inputField.designation != undefined ? "": DesginationErr }
                                    </p>
                                  </div>{" "}
                                  <div className="form-group col-sm-3">
                                    <label htmlFor="lastName"                                         class="form-label"
                                    >
                                      Month Of Experience
                                      {/* <span style={{ color: "red" }}>*</span> */}

                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="lastName"
                                      name="month_of_experience"
                                      value={inputField.month_of_experience}
                                      onChange={(event) => {
                                        handleInputChange(index, event);
                                        //setDesginationErr("");
                                      }}
                                       disabled
                                      autoComplete="off"
                                      // onKeyDown={(evt) =>
                                      //   ["e", "E", "+", "-"].includes(
                                      //     evt.key
                                      //   ) && evt.preventDefault()
                                      // }
                                    />
                                    {/* <p
                                    className="Error"
                                    style={{ paddingLeft: "12px" }}
                                  >
                                    {DesginationErr}
                                  </p> */}
                                  </div>
                                  <div
                                    className="col-12"
                                    // style={{ paddingLeft: "25px" }}
                                  >
                                    <label className="mt-3 form-label">
                                      File Upload
                                      <small
                                        style={{
                                          color: "red",
                                          display: "block",
                                        }}
                                      >
                                                                  Note:Upload the  picture, please.
                                 Verify that the file is in the JPG, JPEG, or 
                                 PNG format and that its size is less than 10 MB.

                                      </small>
                                    </label>

                                    {/* {File.map((File, index) => ( */}

                                    <div
                                      className="col-12"
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                        marginLeft: "-15px",

                                        flexDirection: "column",
                                      }}
                                    >
                                      {/* {images[0] && (
                                        <>
                                          {images.map((item) => {
                                            return (
                                              <img
                                                // src={images[0]}
                                                src={item}
                                                alt="test2"
                                                style={{
                                                  width: "150px",
                                                  height: "150px",
                                                  border: "1px solid #000",
                                                  borderRadius: "10px",
                                                }}
                                              />
                                            );
                                          })}
                                        </>
                                      )} */}

{inputField.Files != undefined && inputField.Files != null && inputField.Files != "" ?                     
                 <img
                                        // src={images[0]}
                                        src={inputField.Files}
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                          border: "1px solid #000",
                                          borderRadius: "10px",
                                        }}
                                      />

                                      :
                                      null }
                                      <Button
                                        className="btn doctorupload"
                                        variant="contained"
                                        component="label"
                                        style={{
                                          background: "#ef4d39",
                                          color: "white",
                                        }}
                                      >
                                        Upload Image
                                        <input
                                          type="file"
                                          hidden
                                          accept="image/png, image/jpeg"
                                          name="file"
                                          // onChange={(e) => handleFiles(e)}
                                          onChange={(event) => {
                                            setforindex(index);
                                            handleInputChange(index, event);
                                            //setDesginationErr("");
                                          }}
                                          ref={fileInputRef}

                                        />
                                      </Button>
                                    </div>

                                    {/* ))} */}
                                  </div>
                                </Fragment>
                              ))}
                              {/* <div className="row" style={{ width: "100%" }}>
                                <div
                                  className="col-12"
                                  style={{ paddingLeft: "25px" }}
                                >
                                  <label className="mt-3">File Upload</label>

                                  {File.map((File, index) => (
                                    // <Fragment key={`${File}~${index}`}>
                                    <div className="col-12">
                                      <Button
                                        className="doctorupload"
                                        variant="contained"
                                        component="label"
                                        style={{
                                          background: "#ef4d39",
                                          color: "white",
                                        }}
                                      >
                                        <p>Upload Image </p>
                                        <input
                                          type="file"
                                          hidden
                                          accept="image/png, image/jpeg"
                                          onChange={(e) => handleFiles(e)}
                                        />
                                      </Button>
                                    </div>
                                    // </Fragment>
                                  ))}
                                </div>
                              </div> */}
                            </div>

                            <div className="submit-button">
                              <br />
                              {/* <pre>{JSON.stringify(inputFields, null, 2)}</pre> */}
                              {/* <pre>{JSON.stringify(File, null, 2)}</pre>{" "} */}
                            </div>
                          </form>
                        </>
                      ) : null}
                      {isAthena ? (
                        <>
                          {renderReferenceSection(
                            "Reference",
                            references,
                            setReferences,
                            REFERENCE_FIELDS,
                          )}
                          {!fresher
                            ? renderReferenceSection(
                                "Previous Employer Reference",
                                previousEmployerReferences,
                                setPreviousEmployerReferences,
                                PREVIOUS_EMPLOYER_REFERENCE_FIELDS,
                              )
                            : null}
                        </>
                      ) : null}
                    </>
                  ) : (
                    <></>
                  )}

                       {(state.NumberCounts.Editable == 2 || state.ClientBranchIDs.SUBROLE == 3) && (state.NumberCounts.EmployeeFormFIll == true)
?
<>

                    
                    <div
                      className="RoleButton"
                      style={{
                        display: "flex",
                        gap: "15px",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "0px 15px",
                        marginBottom: "20px",
                      }}
                    >
                      <button
                        class="btn ButtonCSS"
                        style={{ color: "#ffff", background: "#F26239" }}
                        onClick={(e) => {
                          dispatch(SetActiveTabs(5));
                          // const payload ={
                          //   userid:state.ClientBranchIDs.EmployeeDetailsProfile,
                          //   type:"BIF"
                          // }
                          // dispatch(setPreviousDataFetchActions(payload))
                        }}
                      >
                        Previous
                      </button>

                      <button
                        class="btn ButtonCSS"
                        style={{ color: "#ffff", background: "#EF4D39" }}
                        onClick={(e) => {
                          HandleNext(e);
                        }}
                      >
                        Save & Continue
                      </button>
                    </div>
</>
:                    
                    
                    <>
{
                          state.NumberCounts.Editable == 1 && 
                                            state.SideBarFiles.UserEmailID  == "admin@gmail.com" || state.SideBarFiles.UserEmailID  == "adminit@uds.in" || state.SideBarFiles.UserEmailID  == "codoid@gmail.com" || state.SideBarFiles.UserEmailID  == "admin@uds.in" 
                                            ? 

                        
                    <div
                      className="RoleButton"
                      style={{
                        display: "flex",
                        gap: "15px",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "0px 15px",
                        marginBottom: "20px",
                      }}
                    >
                      <button
                        class="btn ButtonCSS"
                        style={{ color: "#ffff", background: "#F26239" }}
                        onClick={(e) => {
                          dispatch(SetActiveTabs(5));
                          // const payload ={
                          //   userid:state.ClientBranchIDs.EmployeeDetailsProfile,
                          //   type:"BIF"
                          // }
                          // dispatch(setPreviousDataFetchActions(payload))
                        }}
                      >
                        Previous
                      </button>

                      <button
                        class="btn ButtonCSS"
                        style={{ color: "#ffff", background: "#EF4D39" }}
                        onClick={(e) => {
                          HandleNext(e);
                        }}
                      >
                        Save & Continue
                      </button>
                    </div>
                        : null
  
}



                    
</>


}                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={ eventFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() =>setCroppImageView(false)}
        />
      )}

    </>
  );
};

export default PreviousEmp;
